import { createClient } from "contentful";
import path from "path";

const CONTENTFUL_SPACE_ID = process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID;
const CONTENTFUL_ACCESS_TOKEN = process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN;

// Check if we should use cached data (useful for development)
const USE_CACHE = process.env.NODE_ENV === 'development' && process.env.USE_CONTENTFUL_CACHE === 'true';
const CACHE_DIR = path.join(process.cwd(), 'cache', 'contentful');

const client = createClient({
  space: CONTENTFUL_SPACE_ID,
  accessToken: CONTENTFUL_ACCESS_TOKEN,
  host: process.env.NEXT_PUBLIC_CONTENTFUL_API_ENDPOINT,
});

// Function to read cached data
const getCachedData = async (contentType) => {
  if (!USE_CACHE) return null;
  
  try {
    const cacheFile = path.join(CACHE_DIR, `${contentType}.json`);
    const cacheExists = fs.existsSync(cacheFile);
    
    if (!cacheExists) {
      console.log(`📭 No cache found for ${contentType}, fetching from Contentful...`);
      return null;
    }
    
    const cacheContent = fs.readFileSync(cacheFile, 'utf8');
    const cacheData = JSON.parse(cacheContent);
    
    console.log(`📦 Using cached data for ${contentType} (${cacheData.items.length} items, cached: ${new Date(cacheData.cachedAt).toLocaleString()})`);
    return cacheData.items;
  } catch (error) {
    console.warn(`⚠️  Failed to read cache for ${contentType}:`, error.message);
    return null;
  }
};

// Retrieve the list of blog posts from Contentful or cache
const getEntries = async contentType => {
  // Try to get cached data first
  const cachedData = await getCachedData(contentType);
  if (cachedData) {
    console.log(`🌐 Using cached data for ${contentType}`);
    return cachedData;
  }

  console.log("Fetching from Contentful API...", contentType);
  
  // Fallback to live API call
  console.log(`🌐 Fetching ${contentType} from Contentful API...`);
  const response = await client.getEntries({
    content_type: contentType,
  });

  return response.items;
};

export const getEntry = async entryId => {
  const response = await client.getEntry(entryId);
  return response.fields;
};

export default getEntries;
